module.exports = __webpack_public_path__ + "img/MINI.b8342edd.png";